import React, { useEffect, useState, useContext } from "react";
import { Modal, Popconfirm, Spin, Table,notification } from "antd"
import { PlusCircle } from "react-feather"
import { Link } from "react-router-dom"
import { createDepartmentMethod, deleteDepartment, getAllDepartments } from "../../service/ApiServices"
import { getAllEmployeesWithoutPaginationMethod } from "../../service/ApiServices"
import { Select } from "antd"
import { API_BASE_URL } from "../../../src/environment"
import { ArrowLeft } from "lucide-react"
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";

const DepartmentGrid = () => {
  const { user } = useContext(UserContext);
  const [data, setData] = useState([])
  const [success, setSuccess] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [formData, setFormData] = useState({
    id: "",
    departmentName: "",
    HOD: null,
    description: "",
    isCoverup: true
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [search, setSearch] = useState("")
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })

  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]

  const storedUserData = localStorage.getItem("user")
  const userData = JSON.parse(storedUserData)
  const id = userData?.data?.uid
  const [userRightssub, setUserRightssub] = useState([])
  const [employeeData, setEmployeeData] = useState([])
    const [api, contextHolder] = notification.useNotification();
  
    const showNotification = (type, message, description) => {
      api[type]({
        message,
        description,
        placement: 'topRight',
        duration: 4.5,
      });
    };

  useEffect(() => {
    const fetchUserRightssub = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/userright/${id}`)
        if (!response.ok) {
          throw new Error("Failed to fetch user rights")
        }
        const data = await response.json()
        setUserRightssub(data.data || [])
      } catch (error) {
        console.error("Error fetching data:", error)
        setUserRightssub([])
      }
    }

    fetchUserRightssub()
  }, [id])

  const hasJobRightWithedel = userRightssub.some((right) => right.right === "Departments" && right.deletes === 1)

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoading(true)
      try {
        const response = await getAllEmployeesWithoutPaginationMethod({
          setEmployeeData,
        })
                console.error(" fetching employees:", response)

      } catch (error) {
        console.error("Error fetching employees:", error)
      } finally {
        setLoading(false)
      }
    }
    fetchEmployees()
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      const fetchData = async () => {
        getAllDepartments({
          search,
          setLoading: setLoading2,
          setData,
          pagination,
          setPagination,
        })
      }
      fetchData()
    }, 600)

    return () => {
      clearTimeout(handler)
    }
  }, [search, pagination.current])

  useEffect(() => {
    if (success) {
      getAllDepartments({
        search,
        setLoading: setLoading2,
        setData,
        pagination,
        setPagination,
      })
      showSuccess("Successfully saved Department!")
      handleCancel()
      handleReset()
    }
    if (isDelete) {
      getAllDepartments({
        search,
        setLoading: setLoading2,
        setData,
        pagination,
        setPagination,
      })
      showSuccess("Successfully deleted Department!")
    }
  }, [success, isDelete])

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setIsEdit(false)
    setFormData({
      id: "",
      departmentName: "",
      HOD: null,
      description: "",
      isCoverup: true
    })
  }

  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: "HOD",
      dataIndex: "HOD",
      key: "HOD",
      render: (text, record) => {
        if (record.HOD && (record.HOD.full_name || (record.HOD.first_name && record.HOD.last_name))) {
          return record.HOD.full_name ? record.HOD.full_name : `${record.HOD.first_name} ${record.HOD.last_name}`
        }
        return "N/A"
      },
    },
    {
      title: "EPF No",
      dataIndex: "HOD",
      key: "HOD",
      render: (text, record) => {
        return record?.HOD?.epf_number ? record.HOD.epf_number : "N/A"
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            to="#"
            className="me-2 p-2"
            onClick={() => {
              setFormData({
                id: record._id,
                HOD: record.HOD?._id,
                departmentName: record.departmentName,
                description: record.description,
                isCoverup: record.isCoverup
              });
              setIsEdit(true);
              setIsModalOpen(true);
            }}
          >
            <i data-feather="download" className="feather-edit"></i>
          </Link>
          {!hasJobRightWithedel && (
            <Popconfirm
              title="Delete the Department"
              description="Are you sure to delete this Department?"
              onConfirm={() => {
                deleteDepartment({
                  id: record._id,
                  setIsDelete,
                })
              }}
              onCancel={() => {
                console.log("c")
              }}
              okText="Yes"
              cancelText="No"
            >
              <Link className="confirm-text p-2" to="#">
                <i data-feather="trash-2" className="feather-trash-2"></i>
              </Link>
            </Popconfirm>
          )}
        </td>
      ),
    },
  ]

  const handleSubmit = () => {
    if (formData.HOD === null || formData.departmentName === "" || formData.description === "") {
      alert("Please fill all fields")
      return
    }
    createDepartmentMethod({
      data: formData,
      setLoading,
      setSuccess,
    })
  }

  const handleReset = () => {
    setFormData({
      id: "",
      departmentName: "",
      HOD: null,
      description: "",
      isCoverup: true
    })
  }

  const showSuccess = (str) => {
       showNotification('success', 'Good Job !', str);

  }

  return (
    <div className="page-wrapper-lt"> {contextHolder}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container ">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Departments</h4>
                <h6>Manage your Departments</h6>
              </div>
            </div>
            <div className="page-btn">
              <a 
                className={`btn btn-added ${
                  user?.permissions && hasPermission(user.permissions, "HRM", "Departments", "create") 
                    ? '' 
                    : 'disabled'
                }`}
                onClick={() => {
                  if (user?.permissions && hasPermission(user.permissions, "HRM", "Departments", "create")) {
                    setIsEdit(false);
                    setFormData({
                      id: "",
                      HOD: "",
                      departmentName: "",
                      description: "",
                      isCoverup: true
                    });
                    setIsModalOpen(true);
                  }
                }}
                title={
                  !(user?.permissions && hasPermission(user.permissions, "HRM", "Departments", "create"))
                    ? "You don't have permission to create departments" 
                    : "Create new department"
                }
              >
                <PlusCircle className="me-2" />
                Add New
              </a>
            </div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Link className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
                <div className="wordset">
                  <style>
                    {`
      @media (max-width: 767px) {
        .wordset {
          margin-bottom: 25px !important;
        }
      }
    `}
                  </style>
                  <ul>
                    <li>
                      <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="print">
                        <img src="assets/img/icons/printer.svg" alt="print" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Table
                loading={loading2}
                columns={columns}
                dataSource={data}
                rowKey="value"
                pagination={{
                  current: pagination.current,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  total: pagination.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{isEdit ? "Edit" : "Add"} Department</h4>
                  <p className="mb-0">Fill in the required fields to create an Department</p>
                </div>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Department Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.departmentName}
                          onChange={(e) => setFormData({ ...formData, departmentName: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Head of Department</label>
                       <Select
    className="select"
    options={employeeData}
    placeholder="Select an employee"
    value={formData.HOD}
    onChange={(value) => setFormData({ ...formData, HOD: value })}
    allowClear
    showSearch
    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
    style={{ width: "100%", height: "40px" }}
/>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3 summer-description-box">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.description}
                          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <div>
                          <input
                            type="checkbox"
                            checked={formData.isCoverup}
                            onChange={(e) => setFormData({ ...formData, isCoverup: e.target.checked })}
                          />
                          <span className="ms-2">Enable Coverup</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-cancel"
                      onClick={() => {
                        handleCancel()
                      }}
                    >
                      Close
                    </button>

                    <div className="">
                      <button type="button" className="btn btn-reset me-2" onClick={handleReset}>
                        Reset
                      </button>
                      <button type="button" className="btn btn-submit ml-0" onClick={handleSubmit} disabled={loading}>
                        {loading ? <Spin size="small" /> : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  )
}

export default DepartmentGrid